import { MyImage } from '~/components/ui/MyImage'
import { getTabs_aiArtworkResourceModule_aiSquareTab_tab_child } from '~/graphqls/types'

interface Props {
  item?: getTabs_aiArtworkResourceModule_aiSquareTab_tab_child
}

export default function AuthorCard({ item }: Props) {
  const { name } = item || {}
  const { description, artistImage, artworkImage } = item?.tabExtra || {}
  return (
    <div className="flex items-center justify-between p-3 rounded-2xl bg-neutral-200">
      <div className="flex items-center">
        <MyImage
          src={artistImage || ''}
          alt={name || ''}
          className="block w-[120px] h-[120px] rounded-full object-cover"
        />
        <div className="ml-3 w-[700px]">{description}</div>
      </div>
      <div className="flex items-center">
        {artworkImage?.map((item, index) => {
          return (
            <MyImage
              key={item}
              src={item || ''}
              alt=""
              className="block rounded-xl w-[160px] h-[120px] flex-shrink-0 ml-3 object-cover"
            />
          )
        })}
      </div>
    </div>
  )
}
